import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Box } from "@mui/material";

const BackButton = ({ to, label = "Back", sx = {} }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      onClick={handleBack}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        color: "var(--color-primary-dark)",
        fontFamily: "Outfit",
        fontSize: "14px",
        fontWeight: 500,
        width: "fit-content",
        marginBottom: "12px",
        userSelect: "none",
        ...sx,
      }}
    >
      <FaArrowLeft size={14} />
      {label}
    </Box>
  );
};

export default BackButton;
